import { RouterView } from "router/RouterView"

export const App: React.FC = () => {
  return <RouterView />
}

export default App
